export const STATUS_DIMENSIONS = [
  { key: 'status_live',    label: 'Live',    colorClass: 'bg-emerald-500' },
  { key: 'status_sold',    label: 'Sold',    colorClass: 'bg-emerald-300' },
  { key: 'status_okref',   label: 'OKREF',   colorClass: 'bg-slate-300' },
  { key: 'status_pending', label: 'Pending', colorClass: 'bg-slate-400' },
  { key: 'status_waiting', label: 'Waiting', colorClass: 'bg-amber-400' },
  { key: 'status_stale',   label: 'Stale',   colorClass: 'bg-red-400' },
];

export const CONDITION_DIMENSIONS = [
  { key: 'cond_new',    label: 'Neuf',   colorClass: 'bg-emerald-500' },
  { key: 'cond_good',   label: 'Good',   colorClass: 'bg-emerald-300' },
  { key: 'cond_normal', label: 'Normal', colorClass: 'bg-slate-300' },
  { key: 'cond_bad',    label: 'Bad',    colorClass: 'bg-red-400' },
];

export const SCAN_DIMENSIONS = [
  { key: 'scan_in_stock',     label: 'IN_STOCK',     colorClass: 'bg-emerald-500' },
  { key: 'scan_out_of_stock', label: 'Out of stock', colorClass: 'bg-amber-400' },
  { key: 'scan_not_found',    label: 'Not Found',    colorClass: 'bg-red-400' },
];

export function buildSegments(row, dimensions) {
  return dimensions.map((d) => ({ ...d, count: row[d.key] ?? 0 }));
}

export function dimensionTotal(row, dimensions) {
  return dimensions.reduce((sum, d) => sum + (row[d.key] ?? 0), 0);
}

export function lotAgeMonths(dateMin) {
  if (!dateMin) return null;
  const diff = Date.now() - new Date(dateMin).getTime();
  return Math.floor(diff / (30.44 * 24 * 3600 * 1000));
}

export function ecoulementPct(sold, total) {
  if (!total) return 0;
  return Math.round((sold / total) * 100);
}
